//#region DevExtreme Imports

import 'devextreme/ui/form'

//#endregion

import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"
import { ATTACHMENT_SERVICE_NAME } from '../../../services/attachments'

import { IMRBaseComponent } from "../../common/base"

import { IMRTaskValidationController } from "./task-validate.controller"

//#region Asset Imports

import './task-validate.scss'
import * as TEMPLATE from './task-validate.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrTaskValidate'

export class IMRTaskValidationComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: IMRTaskValidationController,
            services: [USER_SESSION_SERVICE_NAME, ATTACHMENT_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}